import { Backend } from '@/_axios';

export default {
  list(page) {
    return Backend.get('/activities/', { params: { page } });
  },
};
